var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ymapMarker',{attrs:{"markerId":_vm.markerId,"coords":_vm.coords,"balloon-template":_vm.balloonTemplate,"options":{
        preset: 'islands#darkBlueAutoCircleIcon',
        hideIconOnBalloonOpen: false,
    }}})
}
var staticRenderFns = []

export { render, staticRenderFns }